import { lazy, Suspense } from 'react';

import { ErrorBoundary } from '@/_components';
import ErrorFallback from '@/_components/error/error-fallback';

import { Loading } from '../bridge-plan/loading';

const PDFTemplateViewer = lazy(() => import('./pdf-template-viewer'));

export function TestPage() {
  return (
    <ErrorBoundary FallbackComponent={<ErrorFallback />}>
      <Suspense fallback={<Loading />}>
        <PDFTemplateViewer />
      </Suspense>
    </ErrorBoundary>
  );
}
